export const Notification = ({message}) => {
    return <p>{message}</p>
}